Service = App.loadClass 'core::Angular/Service'

class exports.DaystoharvestService extends Service
    constructor: (@http, @rootScope, @window) ->
        null

    fetch: () =>
        return @http.post('backend/portal/daystoharvest/fetch')

    save: (days) =>
        return @http.post('backend/portal/daystoharvest/save', {
            days: days
        })

    excel: () =>
        @window.open('backend/portal/daystoharvest/excel', '_blank')
        return true
